export default __webpack_public_path__ + "static/media/theme-dark-blue.56c4ec0f.svg";